import React from "react"
import { createRoot } from "react-dom/client"
import "./assets/scss/index.scss"
import App from "./app"
import reportWebVitals from "./reportWebVitals"
import { LicenseInfo } from "@mui/x-license-pro"
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_KEY as any)
const container = document.getElementById("root")
const root = container ? createRoot(container) : null
if (!root) throw new Error("Root element not found")
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
